import { useState } from "react";

/**
 * Bilingual input/textarea with FR/EN tabs.
 * Stores value as `{fr, en}`. Supports legacy strings by wrapping them.
 */
export default function BilingualField({ label, value, onChange, type = "input", rows = 3, testid }) {
  const [tab, setTab] = useState("fr");
  // Normalize value
  const v = value && typeof value === "object" && ("fr" in value || "en" in value)
    ? { fr: value.fr || "", en: value.en || "" }
    : { fr: typeof value === "string" ? value : "", en: "" };

  const update = (k, val) => onChange({ fr: v.fr, en: v.en, [k]: val });

  const inputCls = "w-full border border-[#2D2A26]/15 rounded-xl px-4 py-2.5 text-sm focus:border-[#C87A5E] outline-none";
  const taCls = "w-full border border-[#2D2A26]/15 rounded-xl px-4 py-3 text-sm focus:border-[#C87A5E] outline-none";

  return (
    <div data-testid={testid}>
      <div className="flex items-center justify-between mb-1.5">
        <label className="overline">{label}</label>
        <div className="flex gap-1 bg-[#F6F3EC] rounded-lg p-1">
          {["fr", "en"].map((l) => (
            <button
              type="button"
              key={l}
              onClick={() => setTab(l)}
              className={`px-2.5 py-0.5 rounded text-xs uppercase tracking-wider transition ${tab === l ? "bg-[#2D2A26] text-white" : "text-[#4A3F35]"}`}
              data-testid={`${testid}-tab-${l}`}
            >
              {l}
            </button>
          ))}
        </div>
      </div>
      {type === "textarea" ? (
        <textarea
          rows={rows}
          value={v[tab]}
          onChange={(e) => update(tab, e.target.value)}
          className={taCls}
          data-testid={`${testid}-input-${tab}`}
        />
      ) : (
        <input
          value={v[tab]}
          onChange={(e) => update(tab, e.target.value)}
          className={inputCls}
          data-testid={`${testid}-input-${tab}`}
        />
      )}
    </div>
  );
}
